import React, { Component } from 'react';
import { connect } from 'react-redux';
import QrReader from 'react-qr-reader';
// import QrReader from 'react-qr-scanner';
import audio from './assets/scanned.mp3';
import { ReactComponent as ScannerImg } from './assets/scanner.svg';
import { ReactComponent as CameraImg } from './assets/camera.svg';
import lang from './lang';
import './Scanner.css';

class Scanner extends Component {
    state = {
        result: 'No result',
        size: 90,
        cameraType: 'environment',
        active: true
    }

    componentWillUnmount() {
        this.setState({ active: false })
    }

    handleScan = data => {
        if (data) {
            this.audio.play()
            this.setState({
                result: data
            });
            setTimeout(() => {
                this.props.history.push('/products/' + data)
            }, 1000)
        }
    }

    handleError = err => {
        console.error(err)
    }

    sizeHandler = () => {
        this.setState({ size: this.rangeValue.value });
    }

    cameraHandler = (value) => {
        const scannerParent = this.scannerRef.parentNode;
        const cameraParent = this.cameraRef.parentNode;
        if (value === 'user') {
            this.scannerRef.style.fill = '#28a745';
            this.cameraRef.style.fill = '#fff';
            cameraParent.classList.add('active');
            scannerParent.classList.remove('active');
        } else {
            this.scannerRef.style.fill = '#fff';
            this.cameraRef.style.fill = '#28a745';
            cameraParent.classList.remove('active');
            scannerParent.classList.add('active');
        }
        console.log(value);
        this.setState({ cameraType: value });
    }

    render() {
        const { scanner, camera } = lang[this.props.user.lang || 'uz']
        return (
            <div className="container text-center" id="scanner-section">
                <audio src={audio} hidden ref={ref => this.audio = ref}></audio>
                <button
                    className="btn btn-outline-success active mr-3 btn-sm"
                    onClick={() => this.cameraHandler('environment')}
                >
                    <ScannerImg
                        ref={ref => this.scannerRef = ref}
                        width="30"
                        fill="#fff"
                        height="30"
                    />
                    <span className="ml-2">{scanner}</span>
                </button>
                <button
                    className="btn btn-outline-success btn-sm"
                    onClick={() => this.cameraHandler('user')}
                >
                    <CameraImg
                        width="30"
                        fill="#28a745"
                        ref={ref => this.cameraRef = ref}
                    />
                    <span className="ml-2">{camera}</span>
                </button>
                <div className="form-group">
                    <input
                        type="range"
                        min="20"
                        max="100"
                        ref={ref => this.rangeValue = ref}
                        onChange={this.sizeHandler}
                        className="form-control"
                        style={{ maxWidth: '300px', margin: 'auto' }}
                    />
                </div>
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                        <div className="qr-wrapper " style={{ width: this.state.size + '%', margin: 'auto' }}>
                            {
                                this.state.active && <QrReader
                                    delay={300}
                                    onError={this.handleError}
                                    onScan={this.handleScan}
                                    style={{ width: '100%' }}
                                    facingMode={this.state.cameraType}
                                />
                            }
                        </div>
                        {/* <p>{this.state.result}</p> */}
                    </div>
                </div>

            </div >
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Scanner);